const About = (): JSX.Element => {
  return <div>About Us Page</div>;
};

export default About;
